//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueIfBot from 'vue-if-bot/dist/vue-if-bot.es';
import { createCookie, readCookie } from '@/utils/cookie';
import { GTM_ID } from '@/utils/gtm';

export default {
  components: {
    VueIfBot,
  },
  data() {
    return {
      show: undefined,
      cookieName: 'cookieconsent_status',
      cookieExpiryDays: 365,
    };
  },
  computed: {
    hasExistingConsent() {
      const cookie = readCookie(this.cookieName);
      return cookie === '1' || cookie === '0';
    },
  },
  beforeMount() {
    this.show = !this.hasExistingConsent;
  },
  methods: {
    saveConsent(granted) {
      createCookie(this.cookieName, granted ? '1' : '0', this.cookieExpiryDays);

      // Update GTM consent
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        const gtagConsent = granted ? 'granted' : 'denied';
        window.gtag('consent', 'update', {
          ad_storage: gtagConsent,
          analytics_storage: gtagConsent,
          ad_user_data: gtagConsent,
          ad_personalization: gtagConsent,
        });
      }

      // Basic consent mode: the GTM container is not injected on boot (see the
      // gtm block in nuxt.config.js), so granting has to load it, not just flip
      // the state. The update above has to reach the dataLayer first, or the
      // first tags evaluate against the denied default.
      if (granted && this.$gtm) {
        this.$gtm.init(GTM_ID);
      }

      // an2.js is held back until consent is given (see integrations/s3.client.js)
      if (
        granted &&
        typeof window !== 'undefined' &&
        typeof window.loadAnalyticsScript === 'function'
      ) {
        window.loadAnalyticsScript();
      }

      this.show = false;
    },
    accept() {
      // The choice first: tracking is gated on the cookie saveConsent writes,
      // so recording the accept beforehand would drop the very event we want.
      this.saveConsent(true);
      this.$tracking.trackEvent('website.cookie-consent.accept', {
        currentURL: this.$route.fullPath,
      });
    },
    reject() {
      this.saveConsent(false);

      // Deliberately after the choice, so the consent gate drops it: someone
      // who declined should not have their decline reported. The call is kept
      // so the intent stays visible, and rejections remain countable in
      // aggregate as page views minus accepts.
      this.$tracking.trackEvent('website.cookie-consent.reject', {
        currentURL: this.$route.fullPath,
      });
    },
  },
};
